import { ButtonTriggerEvent } from '../';

export class ConfirmModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class ConfirmModalData {
    confirmModalIcon?: string;
    confirmModalTitle?: string;
    confirmModalDescription?: string;
    confirmModalConfirmButtonText?: string;
    confirmModalCancelButtonText?: string;
    isAsync?: boolean;
    color?: string;
    confirmCheckboxDescription?: string;
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/confirm.modal/confirm.modal.provider.ts